import { IconButton } from '@material-ui/core';
import IconClose from '@material-ui/icons/Close';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const PopupCloseButton = ({ className, dataTestId, ...props }) => {
  const styles = useStyles();

  return (
    <IconButton
      className={cx(styles.root, className)}
      data-testid={`${dataTestId ? dataTestId + '_' : ''}popupCloseButton`}
      {...props}
    >
      <IconClose />
    </IconButton>
  );
};

PopupCloseButton.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};
PopupCloseButton.defaultProps = {
  className: null,
  dataTestId: null,
};
